module.exports = __webpack_public_path__ + "img/s3-0.f9cec66d.svg";